import React from "react";
import { InspectableLineChart, Series } from "../../../components/Charts";
import {
  ChartLegend,
  ChartLegendDot,
  ChartLegendItem,
  ChartLegendLabel,
  ChartTitle,
  EmptyStateText,
  TimelineHeader,
} from "../styles";
import { BREAKPOINTS } from "../../../utils/constants";

interface TimelineChartContentProps {
  timelineSeries: Series[];
  timelineLabels: string[];
  windowWidth: number;
}

export const TimelineChartContent: React.FC<TimelineChartContentProps> =
  React.memo(
    ({ timelineSeries, timelineLabels, windowWidth }): React.ReactElement => {
      if (timelineLabels.length === 0 || timelineSeries.length === 0) {
        return <EmptyStateText>No historical data available</EmptyStateText>;
      }

      return (
        <>
          <TimelineHeader>
            <ChartTitle>Assets · Liabilities</ChartTitle>
            <ChartLegend>
              {timelineSeries.map((s) => (
                <ChartLegendItem key={s.label}>
                  <ChartLegendDot
                    $color={s.color ?? "var(--color-text-secondary)"}
                  />
                  <ChartLegendLabel>{s.label}</ChartLegendLabel>
                </ChartLegendItem>
              ))}
            </ChartLegend>
          </TimelineHeader>
          <InspectableLineChart
            inspectLabel="Inspect net worth by date"
            readoutTestId="timeline-readout"
            height={windowWidth < BREAKPOINTS.tabletMin ? 350 : 400}
            series={timelineSeries}
            xLabels={timelineLabels}
            hideLegend
          />
        </>
      );
    },
  );

TimelineChartContent.displayName = "TimelineChartContent";
